import React from 'react'
import Checkbox from '@chegg-wt/core/components/Checkbox'
import ProjectItemMenu from '@chegg-wt/core/components/ProjectItemMenu'

import * as Styled from './styled'
import { ProjectItemsMenuProps } from './types'

const ProjectItemsMenu: React.FunctionComponent<ProjectItemsMenuProps> = ({
  numItems,
  onDelete,
  onMove,
  onEdit,
  clearAllSelected,
  selectAll,
}) => (
  <Styled.ProjectItemsMenu data-test="sticky-menu">
    <Styled.ProjectItemsLeft>
      <Checkbox
        id="toggle-all"
        selected={numItems !== 0}
        onChange={clearAllSelected}
        label="deselect all projects"
      />
      <Styled.SelectedText data-test="num-items">{numItems} selected</Styled.SelectedText>
      <Styled.SelectAll data-test="select-all" onClick={selectAll} tabIndex={0}>
        select all
      </Styled.SelectAll>
      |
    </Styled.ProjectItemsLeft>
    <ProjectItemMenu
      onMove={onMove}
      onEdit={onEdit}
      onDelete={onDelete}
      hideEdit={numItems > 1}
    />
  </Styled.ProjectItemsMenu>
)

export default ProjectItemsMenu
